import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";

const name = 'NotaFiscalPedidoExpedidoFaturado'

export default {
  name,

  components:{ 
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
  },

  props: { },

  mounted() { },

  updated() { },

  data() {
    return { 
      executarvisualizacao: 0,
      linhaSelecionada: {},
      pdfdownload: false,
      pdfvisualizacao: false,
      PedidoId: null,
      renderiza: false,
    }
  },

  methods: { 
    voltar() {
      this.$router.push(`/pedido-expedido-faturado`);
    },

    imprimir()
    {  
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      this.executarvisualizacao++
    },

    generatePdf() {
      this.executarvisualizacao++
    },

    gerarPdf() {
      this.generatePdf()
    },
  },

  computed: { }
};